import { HttpResponse } from '@angular/common/http';

export class FileUtility {

  constructor() {}

  static getFileName(response: HttpResponse<Blob>) {
    let filename: string;
    try {
      const contentDisposition: string = response.headers.get('content-disposition') as string;
      const r = new RegExp(/(?:filename=")(.+)"/)
      filename = (r.exec(contentDisposition) as any[])[1];
    }
    catch (e) {
      filename = 'arisgan.pdf'
    }
    return filename
  }


  static downloadFile(response: HttpResponse<Blob>) {
    let filename: string = this.getFileName(response)
    let binaryData = [];
    binaryData.push(response.body);
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(new Blob(binaryData as any, { type: 'blob' }));
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

}
